const ItemList = ({ items, color }) => <ol>
  {items.map((item, index) => {
    return <li className="relative pl-12 mb-4" key={index}>
      <span className={'absolute w-8 h-8 text-center rounded-full border border-' + color + ' text-' + color + ' font-bold block left-0 top-0'} style={{ paddingTop: '3px' }}>{index + 1}</span>
      {item.title && <h3 className={'text-xl font-sans font-bold text-' + color + ' mb-2'}>{item.title}</h3>}
      <p className="text-gray-700">{item.text}</p>
    </li>
  })}
</ol>

export default ItemList
